import { ColorScheme } from '../../types/bitkit';

const AlertTheme = {
  baseStyle({ colorScheme }: { colorScheme: ColorScheme }) {
    return {
      body: { display: 'flex', flexDirection: 'column' },
      container: {
        alignItems: 'start',
        bg: `${colorScheme}.95`,
        borderColor: `${colorScheme}.80`,
        borderRadius: '8',
        borderWidth: '1px',
        color: `${colorScheme}.40`,
        display: 'flex',
        gap: '8',
        padding: '12',
        textStyle: 'comp/notification/message',
      },
      icon: {
        h: 24,
        marginEnd: 8,
        w: 24,
      },
      title: {
        textStyle: 'comp/notification/title',
      },
    };
  },
  defaultProps: {
    colorScheme: 'blue',
  },
  parts: ['container', 'title', 'icon', 'body'],
};
export default AlertTheme;
